import script from "./goRinSyo0045.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0045.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0045.vue?vue&type=style&index=0&id=c01f5b4a&lang=scss"

const __exports__ = script;

export default __exports__